import React, {useEffect, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import {socket} from "../component/soket";
import ReCAPTCHA from "react-google-recaptcha";

function Settings() {
    const [info, setInfo] = useState("");
    const [login, setLogin] = useState(false);
    const {register, handleSubmit} = useForm();
    const recaptchaRef = useRef();
    const recaptchaRef2 = useRef();

    function Circle_log(user_info) {
        let content2 = [];
        for (let i = 0; i < user_info.length; i++) {
            content2.push(
                <div key={i} className="body-table row">
                    <div>{i + 1}</div>
                    <div> {user_info[i].common_key}</div>
                    <div>{user_info[i].rare_key}</div>
                    <div> {user_info[i].epic_key}</div>
                    <div> {user_info[i].grenade}</div>
                    <div> {user_info[i].snowball}</div>
                    <div> {user_info[i].king}</div>
                    <div> {user_info[i].firework}</div>
                    <div> {user_info[i].repair}</div>
                    <div> {user_info[i].protection}</div>
                    <div> {user_info[i].damage}</div>
                    <div> {user_info[i].boost}</div>
                    <div> {user_info[i].point_one === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_two === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_three === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_four === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_five === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_six === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_seven === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].cell}</div>
                    <div> {user_info[i].user_energy}</div>
                    <div> {user_info[i].step * 10}</div>
                    <div> {user_info[i].createdAt}</div>
                </div>
            );
        }

        return content2;
    }

    function Circle(user_info) {
        let content = [];
        for (let i = 0; i < Object.keys(user_info).length; i++) {
            content.push(
                <div key={i} className="body-table row">
                    <div> {i + 1}</div>
                    <div> {user_info[i].common_key}</div>
                    <div> {user_info[i].rare_key}</div>
                    <div> {user_info[i].epic_key}</div>
                    <div> {user_info[i].grenade}</div>
                    <div> {user_info[i].king}</div>
                    <div> {user_info[i].firework}</div>
                    <div> {user_info[i].snowball}</div>
                    <div> {user_info[i].repair}</div>
                    <div> {user_info[i].protection}</div>
                    <div> {user_info[i].damage}</div>
                    <div> {user_info[i].boost}</div>
                    <div> {user_info[i].point_one === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_two === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_three === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_four === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_five === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_six === 1 ? "да" : "нет"}</div>
                    <div> {user_info[i].point_seven === 1 ? "да" : "нет"}</div>
                </div>
            );
        }

        return content;
    }

    function CreateTable(user_info) {
        const data = user_info.log[user_info.log.length - 1];
        const log = user_info.log;
        const prize = data.give_prize;

        return (
            <>
                <h2>Основная информация:</h2>
                <div className="d-flex flex-column table">
                    <div className="header-table row">
                        <div>№ (TO_ID)</div>
                        <div>Имя</div>
                        <div>Шагов сделано</div>
                        <div>Текущая клетка</div>
                        <div>Потрачено Energy</div>
                        <div>Заработано Energy</div>
                        <div>Ключ Common</div>
                        <div>Ключ Rare</div>
                        <div>Ключ Epic</div>
                        <div>Гранаты</div>
                        <div>Гранаты-Снежки</div>
                        <div>Гранаты-Царь</div>
                        <div>Гранаты-Фейрверк</div>
                        <div>Ремкомплект</div>
                        <div>Повышенная защита</div>
                        <div>Повышенный урон</div>
                        <div>Ускорение</div>
                        <div>Награда 1</div>
                        <div>Награда 2</div>
                        <div>Награда 3</div>
                        <div>Награда 4</div>
                        <div>Награда 5</div>
                        <div>Награда 6</div>
                        <div>Награда 7</div>
                    </div>
                    <div className="body-table row">
                        <div> {user_info.user_to_id}</div>
                        <div> {user_info.username}</div>
                        <div> {data.step}</div>
                        <div> {data.cell}</div>
                        <div> {data.step * 10}</div>
                        <div> {data.user_energy}</div>
                        <div> {data.common_key}</div>
                        <div> {data.rare_key}</div>
                        <div> {data.epic_key}</div>
                        <div> {data.grenade}</div>
                        <div> {data.snowball}</div>
                        <div> {data.king}</div>
                        <div> {data.firework}</div>
                        <div> {data.repair}</div>
                        <div> {data.protection}</div>
                        <div> {data.damage}</div>
                        <div> {data.boost}</div>
                        <div> {data.point_one === 1 ? "да" : "нет"}</div>
                        <div> {data.point_two === 1 ? "да" : "нет"}</div>
                        <div> {data.point_three === 1 ? "да" : "нет"}</div>
                        <div> {data.point_four === 1 ? "да" : "нет"}</div>
                        <div> {data.point_five === 1 ? "да" : "нет"}</div>
                        <div> {data.point_six === 1 ? "да" : "нет"}</div>
                        <div> {data.point_seven === 1 ? "да" : "нет"}</div>
                    </div>
                </div>
                <h2>Полученные призы за каждый чекпоинт:</h2>
                <div className="d-flex flex-column table">
                    <div className="header-table row">
                        <div>№ (номер круга)</div>
                        <div>Ключ Common</div>
                        <div>Ключ Rare</div>
                        <div>Ключ Epic</div>
                        <div>Гранаты</div>
                        <div>Гранаты-Снежки</div>
                        <div>Гранаты-Царь</div>
                        <div>Гранаты-Фейрверк</div>
                        <div>Ремкомплект</div>
                        <div>Повышенная защита</div>
                        <div>Повышенный урон</div>
                        <div>Ускорение</div>
                        <div>Награда 1</div>
                        <div>Награда 2</div>
                        <div>Награда 3</div>
                        <div>Награда 4</div>
                        <div>Награда 5</div>
                        <div>Награда 6</div>
                        <div>Награда 7</div>
                        <div>Дата получения приза</div>
                    </div>
                    {Circle(prize)}
                </div>

                <h2>Шаги: (призы добавляются с каждым шагом)</h2>
                <div className="d-flex flex-column table big-table">
                    <div className="header-table row">
                        <div>№ (номер хода)</div>
                        <div>Ключ Common</div>
                        <div>Ключ Rare</div>
                        <div>Ключ Epic</div>
                        <div>Гранаты</div>
                        <div>Гранаты-Снежки</div>
                        <div>Гранаты-Царь</div>
                        <div>Гранаты-Фейрверк</div>
                        <div>Ремкомплект</div>
                        <div>Повышенная защита</div>
                        <div>Повышенный урон</div>
                        <div>Ускорение</div>
                        <div>Награда 1</div>
                        <div>Награда 2</div>
                        <div>Награда 3</div>
                        <div>Награда 4</div>
                        <div>Награда 5</div>
                        <div>Награда 6</div>
                        <div>Награда 7</div>
                        <div>Клетка</div>
                        <div>Сколько было заработано энергии</div>
                        <div>Сколько в данный момент потрачено энергии</div>
                        <div>Дата хода</div>
                    </div>
                    {Circle_log(log)}
                </div>
            </>
        );
    }

    const onSubmit = async (data, e) => {
        if (!(recaptchaRef.current.getValue() === "")) {
            const sendData = {
                password: data.password,
                search: data.search,
                recaptcha: recaptchaRef.current.getValue(),
            };
            socket.emit("data_users", sendData);
            e.target.reset(); // reset after form submit
            recaptchaRef.current.reset();
        } else {
            setInfo("ERROR_NO_CAPTCHA");
        }
    };

    const onSubmit2 = async (data, e) => {
        const sendData = {
            token: localStorage.getItem("token_admin"),
            search: data.search,
            recaptcha: recaptchaRef2.current.getValue(),
        };
        socket.emit("data_users", sendData);
        recaptchaRef2.current.reset();
    };

    useEffect(() => {
        const token_admin = localStorage.getItem("token_admin")
            ? localStorage.getItem("token_admin")
            : false;
        if (token_admin) {
            setLogin(true);
        }
    }, []);

    useEffect(() => {
        //listen socket

        socket.on("data_users", (data) => {
            const token_admin = localStorage.getItem("token_admin");
            if (data !== null) {
                if (data.error) {
                    alert(data.error);
                    if (
                        data.error === "LOG_TOKEN_TEXT" ||
                        data.error === "ERROR_DATA_USER"
                    ) {
                        localStorage.removeItem("token_admin");
                        window.location.reload();
                    }
                    // setInfo(data.error)
                } else if (data.log) {
                    setInfo(CreateTable(data));
                    setLogin(true);
                    if (!token_admin) {
                        localStorage.setItem("token_admin", data.token);
                    }
                } else {
                    // setLogin(true)
                    // localStorage.setItem('token_admin', data.token_admin);
                }
            } else {
                localStorage.removeItem("token_admin");
                window.location.reload();
            }
        });

        //disable socket
        return () => {
            socket.off("data_users");
        };
    }, []);

    return (
        <>
            {!login && (
                <div className="login_setting">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <input
                            required={true}
                            name="password"
                            placeholder="password"
                            autoComplete="off"
                            {...register("password")}
                        />
                        <input
                            required={true}
                            name="search"
                            placeholder="search"
                            autoComplete="off"
                            {...register("search")}
                        />
                        <ReCAPTCHA
                            theme="dark"
                            className="recap"
                            ref={recaptchaRef}
                            sitekey="6LfNI_srAAAAACptxRSLfhdOMuyZuYJq1d5khles"
                        />
                        <input value={"Войти"} type="submit"/>
                    </form>
                </div>
            )}
            {login && (
                <div className="login_setting search_setting">
                    <form onSubmit={handleSubmit(onSubmit2)}>
                        <input
                            name="search"
                            placeholder="Имя игрока или TO_ID"
                            autoComplete="off"
                            {...register("search")}
                        />
                        <ReCAPTCHA
                            theme="dark"
                            className="recapy"
                            ref={recaptchaRef2}
                            sitekey="6LfNI_srAAAAACptxRSLfhdOMuyZuYJq1d5khles"
                        />
                        <input value={"Поиск"} type="submit"/>
                    </form>
                </div>
            )}

            <div className="table_users">
                <div> {info} </div>
            </div>
        </>
    );
}

export default Settings;
